import { io } from 'socket.io-client';
import config from '../configs/config';

// "undefined" means the URL will be computed from the `window.location` object
export const URL_SOCKET_CARD = `${config.socket_url}/card`;
export const URL_SOCKET_PURCHASE = `${config.socket_url}/purchase`;